import { Button, ButtonToolbar } from "@shared-forms";
import { getStatusText, getProgress } from "core/lib/get-status-text";
import { Installation } from "core/models/installation-response";
import InstallationProgressBar from "./installation-progress-bar";

type InstallationDetailsProps = {
    installation: Installation,
    onBack: () => void
}

const InstallationDetails = (props: InstallationDetailsProps) => {
    const { installation, onBack } = props;

    const subscriber = installation.subscriberDetails;

    const address = installation.subscriberDetails.genericAddress;

    let date = "";
    let time = "";

    if (installation.appointment) {
        const dateParts = installation.appointment.split(" ");
        date = dateParts[0];
        time = dateParts[1];
    }

    const status = getStatusText(installation.state);

    const progress = getProgress(installation.state);

    const onSite = installation.on_site;

    //Note: Repetition of installation date, time & status

    return (<>
        <div className="installation-details-header">
            <h2>
                {subscriber.customerFirstName} {subscriber.customerSurname}
            </h2>

            <dl>
                <dt>Installation Date:</dt>
                <dd> {date}</dd>

                <dt>Time:</dt>
                <dd>{time}</dd>

                <dt>Reference:</dt>
                <dd>{installation.customer_ref}</dd>
            </dl>
        </div>

        <h3>Installation Status:</h3>

        <InstallationProgressBar status={progress} />

        <div className="installation-details">
            <h3>
                <i className="icon icon-profile" />
                Scheduled Installation
            </h3>

            <dl>
                <dt>Installation Date:</dt>
                <dd>{date}</dd>

                <dt>Time:</dt>
                <dd>{time}</dd>

                <dt>Status:</dt>
                <dd>{status}</dd>

                <dt>Address:</dt>
                <dd>{address}</dd>
            </dl>

            <h4>On-Site Person</h4>

            <dl>
                <dt>Name:</dt>
                <dd>{onSite.person}</dd>

                {onSite.contact_number && <>
                    <dt>Contact:</dt>
                    <dd>{onSite.contact_number}</dd>
                </>}
            </dl>
        </div>

        <ButtonToolbar>
            <Button colour="primary" onClick={onBack} text="Back" className="back" />
        </ButtonToolbar>
    </>);
}

export default InstallationDetails;
